import { IconSizes } from '@newcore/icons';
import { cn } from '../../utils/cn';
import { Spinner } from './spinner';

export interface LoadingStateProps {
  message?: string;
  className?: string;
}

export function LoadingState({ message, className }: LoadingStateProps) {
  return (
    <div className={cn('flex items-center justify-center p-8', className)}>
      <Spinner size={IconSizes.MD} />
      {message && <span className='ml-3 text-tertiary'>{message}</span>}
    </div>
  );
}
